export const usersColumns = ['Nome', 'Permissão', 'Último Acesso', 'Status'];

export const usersRankingColumns = ['Posição', 'Nome', 'Pontos'];
